import React, { useEffect, useState } from "react"
import { AppBar, Fade, Modal, Tab, Tabs } from "@mui/material"
import { isNull } from "lodash"
import LanguageToggle, {
  LANGUAGES,
} from "components/Disclaimer/components/LanguageToggle"
import DisclaimerTabWrapper from "components/Disclaimer/components/DisclaimerTabWrapper"
import Provider from "components/Disclaimer/components/Provider"
import LegalNotice from "components/Disclaimer/components/LegalNotice"
import Privacy from "components/Disclaimer/components/Privacy"
import Credits from "components/Disclaimer/components/Credits"

const legalNoticeStyle = {
  container: {
    display: "flex",
    alignItems: "flex-start",
    paddingTop: 100,
    justifyContent: "center",
  },
  body: {
    backgroundColor: "white",
    width: "80%",
    maxWidth: 800,
    height: "80%",
    overflow: "scroll",
  },
}

export const DISCLAIMER_TABS = {
  PROVIDER: {
    title: {
      [LANGUAGES.EN]: "Provider",
      [LANGUAGES.DE]: "Impressum",
    },
    index: 0,
  },
  LEGAL_NOTICES: {
    title: {
      [LANGUAGES.EN]: "Legal Notices",
      [LANGUAGES.DE]: "Rechtliche Hinweise",
    },
    index: 1,
  },
  PRIVACY_STATEMENT: {
    title: {
      [LANGUAGES.EN]: "Privacy Statement",
      [LANGUAGES.DE]: "Datenschutz",
    },
    index: 2,
  },
  CREDITS: {
    title: {
      [LANGUAGES.EN]: "Third Party License Notices",
      [LANGUAGES.DE]: "Lizenzhinweise Dritter",
    },
    index: 3,
  },
}

const a11yPropsDisclaimer = title => {
  return {
    id: `disclaimer tab ${title}`,
    "aria-controls": `disclaimer tab panel ${title}`,
  }
}

const Disclaimer = ({ disclaimerOpenTab, setDisclaimerOpenTab }) => {
  const [currentTab, setCurrentTab] = useState(disclaimerOpenTab)
  const [currentLanguage, setCurrentLanguage] = useState(LANGUAGES.EN)

  useEffect(() => {
    if (!isNull(disclaimerOpenTab)) setCurrentTab(disclaimerOpenTab)
  }, [disclaimerOpenTab])

  return (
    <Modal
      aria-labelledby="disclaimer modal"
      aria-describedby="provider and legal notices"
      open={!isNull(disclaimerOpenTab)}
      onClose={() => setDisclaimerOpenTab(null)}
      closeAfterTransition
      css={legalNoticeStyle.container}
    >
      <Fade in={!isNull(disclaimerOpenTab)}>
        <div css={legalNoticeStyle.body}>
          <AppBar position="static">
            <Tabs
              style={{ backgroundColor: "white" }}
              value={currentTab}
              onChange={(e, newIndex) => setCurrentTab(newIndex)}
              aria-label="disclaimer tabs group"
              scrollButtons="auto"
              variant="scrollable"
              indicatorColor="primary"
              textColor={"primary"}
            >
              {Object.values(DISCLAIMER_TABS).map(t => (
                <Tab
                  key={t.index}
                  label={t.title[currentLanguage]}
                  {...a11yPropsDisclaimer(t.title[currentLanguage])}
                />
              ))}
            </Tabs>
          </AppBar>
          <DisclaimerTabWrapper
            value={currentTab}
            currentLanguage={currentLanguage}
            tab={DISCLAIMER_TABS.PROVIDER}
          >
            <LanguageToggle {...{ currentLanguage, setCurrentLanguage }}>
              <Provider {...{ currentLanguage }} />
            </LanguageToggle>
          </DisclaimerTabWrapper>
          <DisclaimerTabWrapper
            currentLanguage={currentLanguage}
            value={currentTab}
            tab={DISCLAIMER_TABS.LEGAL_NOTICES}
          >
            <LanguageToggle {...{ currentLanguage, setCurrentLanguage }}>
              <LegalNotice {...{ currentLanguage, setDisclaimerOpenTab }} />
            </LanguageToggle>
          </DisclaimerTabWrapper>
          <DisclaimerTabWrapper
            currentLanguage={currentLanguage}
            value={currentTab}
            tab={DISCLAIMER_TABS.PRIVACY_STATEMENT}
          >
            <LanguageToggle {...{ currentLanguage, setCurrentLanguage }}>
              <Privacy {...{ currentLanguage }} />
            </LanguageToggle>
          </DisclaimerTabWrapper>

          <DisclaimerTabWrapper
            currentLanguage={currentLanguage}
            value={currentTab}
            tab={DISCLAIMER_TABS.CREDITS}
          >
            <LanguageToggle {...{ currentLanguage, setCurrentLanguage }}>
              <Credits {...{ currentLanguage }} />
            </LanguageToggle>
          </DisclaimerTabWrapper>
        </div>
      </Fade>
    </Modal>
  )
}

export default Disclaimer
